import React from 'react';
import { AppBar, IconButton, Toolbar, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import headerStyles from '../../../menu/trackfavmenu.module.css';
import styles from './header.module.css';
import CloseMenuBtn from '../btns/CloseMenuBtn';

export default function HeaderNoUnderline({
    title,
    onClose,
    showBackButton = false,
    rightContent = null,
    toolbarProps = {},
    appBarProps = {},
    titleId = undefined,
}) {
    const { className: toolbarClassName, ...restToolbarProps } = toolbarProps;
    const mergedToolbarClassName = [headerStyles.toolbar, toolbarClassName].filter(Boolean).join(' ');

    return (
        <AppBar
            position="static"
            className={headerStyles.appbar}
            sx={{ boxShadow: 'none !important', borderBottom: 'none !important' }}
            {...appBarProps}
        >
            <Toolbar className={mergedToolbarClassName} {...restToolbarProps}>
                <IconButton
                    id={showBackButton ? 'se-button-back' : 'se-button-close'}
                    variant="contained"
                    type="button"
                    className={styles.closeBtn}
                    onClick={onClose}
                >
                    {showBackButton ? <ArrowBackIcon /> : <CloseIcon />}
                </IconButton>
                <Typography component="div" className={headerStyles.title} sx={{ flexGrow: 1 }} id={titleId}>
                    {title}
                </Typography>
                {rightContent}
                {showBackButton && <CloseMenuBtn />}
            </Toolbar>
        </AppBar>
    );
}
